import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = ["aria-label"];
const _hoisted_2 = ["aria-pressed", "aria-label", "title", "onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_UiIcon = _resolveComponent("UiIcon");
  return _openBlock(), _createElementBlock("div", {
    class: "theme-control",
    role: "group",
    "aria-label": _ctx.$t('modern.appearance')
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modes, mode => {
    return _openBlock(), _createElementBlock("button", {
      key: mode.value,
      type: "button",
      class: _normalizeClass({
        active: $options.selected === mode.value
      }),
      "aria-pressed": $options.selected === mode.value,
      "aria-label": _ctx.$t('modern.' + mode.value),
      title: _ctx.$t('modern.' + mode.value),
      onClick: $event => $options.select(mode.value)
    }, [_createVNode(_component_UiIcon, {
      name: mode.icon
    }, null, 8, ["name"]), _createElementVNode("span", null, _toDisplayString(_ctx.$t('modern.' + mode.value)), 1)], 10, _hoisted_2);
  }), 128))], 8, _hoisted_1);
}